import React from 'react'
import { useInvalidateTotpMutation } from '../api/SharedApiSlice'
import { ClearSessionOnSignOut } from '../utilities/LogoutUtils'
import { useMsal } from '@azure/msal-react'
import { Logger } from '../../system/appinsights/Logger'
import { useAppSelector } from '../../store/hooks'
import { getUAuthAuthenticated } from '../../store/slice'

type SignoutProps = {
  postLogoutRedirectUri?: string | null
}

const useAppSignout = () => {
  const { instance: msalInstance, accounts: msalAccounts } = useMsal()
  const [invalidateTotp] = useInvalidateTotpMutation()
  const isUAuthAuthenticated = useAppSelector(getUAuthAuthenticated)
  const handleSignout = React.useCallback(
    async (props?: SignoutProps | null) => {
      const { postLogoutRedirectUri } = props ?? {}
      Logger.LogInfo({ message: 'AppSignOut::Invalidate totp session key intitated.' })
      invalidateTotp()
        .unwrap()
        .finally(() => {
          Logger.LogInfo({
            message: 'AppSignOut::Clearing totp session key from session storage and initating logout.'
          })
          ClearSessionOnSignOut()
          if (isUAuthAuthenticated) {
            window.location.href = postLogoutRedirectUri ?? '/'
            return
          }
          msalInstance
            ?.logoutRedirect({ account: msalAccounts?.[0], postLogoutRedirectUri: postLogoutRedirectUri })
            .catch(() => {
              Logger.LogException({ message: 'Logout redirect failed', exceptionType: 'MSAL' })
            })
        })
    },
    [invalidateTotp, isUAuthAuthenticated, msalAccounts, msalInstance]
  )
  return { handleSignout }
}

export default useAppSignout
